import { format } from 'date-fns';

import AverageGapColumn from '../Components/ActiveOneOnOneComponents/AverageGapColumn';
import CompletionComponent from '../Components/ActiveOneOnOneComponents/CompletionComponent';
import EmployeeData from '../Components/ActiveOneOnOneComponents/EmployeeData';
import { HeaderTooltip } from '../Components/ActiveOneOnOneComponents/HeaderTooltip';
import OneOnOneSetup from '../Components/ActiveOneOnOneComponents/OneOnOneSetup';
import SatisfactionScoreColumn from '../Components/ActiveOneOnOneComponents/SatisfactionScoreColumn';
import ThemeDistributionColumn from '../Components/ActiveOneOnOneComponents/ThemeDistributionColumn';
import ArchivalComponent from '../Components/ArchivedOneOnOneComponents/ArchivalComponent';
import PastOneOnOneSetup from '../Components/ArchivedOneOnOneComponents/PastOneOnOneSetup';

export const oneOnOneLandingPageColumnDefs = {
  employee: ({ id }) => ({
    colId: id,
    field: id,
    filter: 'agSetColumnFilter',
    suppressColumnsToolPanel: true,
    sortable: true,
    flex: 1,
    headerName: 'Name',
    // pinned: 'left',
    lockPosition: 'left',
    minWidth: 250,
    cellRenderer: EmployeeData,
    valueGetter: (params) => params?.data?.employee?.value?.employeeMiniProfile?.displayName,
    filterOptions: ['contains', 'notContains'],
    debounceMs: 200,
    getQuickFilterText: (params) => params?.data?.employee?.value?.employeeMiniProfile?.displayName,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
  }),
  averageGap: ({ id }) => ({
    colId: id,
    field: id,
    filter: 'agNumberColumnFilter',
    minWidth: 150,
    headerName: 'Average Gap',
    cellRenderer: AverageGapColumn,
    valueGetter: (params) => params?.data.averageGap?.value,
    sortable: true,
    filterValueGetter: ({ data }) => Number(data?.averageGap?.value) ?? 0,
  }),
  completionPercentage: ({ id }) => ({
    colId: id,
    field: id,
    minWidth: 200,
    headerName: 'Completion \n',
    filter: 'agNumberColumnFilter',
    headerTooltip: HeaderTooltip,
    tooltipComponent: HeaderTooltip,
    filterValueGetter: ({ data }) => data && data[id]?.value !== null && Number(data[id]?.value),
    valueGetter: ({ data }) => data && (typeof data[id]?.value === 'number' ? `${data[id]?.value ?? 0}%` : null),
    cellRenderer: CompletionComponent,
    sortable: true,
  }),
  nextOneOnOne: ({ id }) => ({
    colId: id,
    field: id,
    sortable: true,
    headerName: 'Next 1:1',
    minWidth: 210,
    cellRenderer: OneOnOneSetup,
    valueGetter: (params) => {
      const nextInstanceTS = params?.data?.nextOneOnOne?.value?.nextInstanceTS;
      if (nextInstanceTS !== undefined && nextInstanceTS !== null) {
        return format(new Date(nextInstanceTS * 1000), 'PPp');
      }
      return nextInstanceTS;
    },
    filter: 'agSetColumnFilter',
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
  }),
  archivalTime: ({ id }) => ({
    colId: id,
    field: id,
    sortable: true,
    minWidth: 200,
    headerName: 'Archived On',
    cellRenderer: ArchivalComponent,
    valueGetter: (param) =>
      param?.data?.archivalTime?.value
        ? format(new Date(param?.data?.archivalTime?.value), 'PP')
        : param?.data?.archivalTime?.value,
    filter: 'agSetColumnFilter',
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
  }),
  lastOneOnOneTime: ({ id }) => ({
    colId: id,
    field: id,
    sortable: true,
    headerName: 'Last 1:1',
    minWidth: 210,
    cellRenderer: PastOneOnOneSetup,
    valueGetter: (param) =>
      param?.data?.lastOneOnOneTime?.value
        ? format(new Date(param?.data?.lastOneOnOneTime?.value), 'PPp')
        : param?.data?.lastOneOnOneTime?.value,
    filter: 'agSetColumnFilter',
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
  }),
  satisfactionScore: ({ id }) => ({
    colId: id,
    field: id,
    headerName: 'Satisfaction Score',
    filter: 'agNumberColumnFilter',
    minWidth: 160,
    cellRenderer: SatisfactionScoreColumn,
    valueGetter: (params) => params?.data?.satisfactionScore?.value,
    sortable: true,
    filterValueGetter: ({ data }) => Number(data?.satisfactionScore?.value) ?? 0,
  }),
  themeDistribution: ({ id }) => ({
    colId: id,
    field: id,
    minWidth: 270,
    headerName: 'Topic Distribution',
    suppressHeaderMenuButton: true,
    sortable: false,
    cellRenderer: ThemeDistributionColumn,
    valueGetter: (params) => params?.data?.TopicDistributionSplitBar?.value,
  }),
};
